export const updateDispatchStart = (date) => ({
  type: "DISPATCH_UPDATE_START",
  payload: date
});

export const updateDispatchEnd = (date) => ({
  type: "DISPATCH_UPDATE_END",
  payload: date
});
